<script lang="ts">
	import * as m from '$paraglide/messages';
	import DatasheetDetailBlock from './DatasheetDetailBlock.svelte';

	export let streetName: string | undefined;
	export let city: string | undefined;
</script>

<DatasheetDetailBlock title={m.poi_datasheet__location()}>
	<address class="font-not-italic">
		{#if streetName}{streetName}<br />{/if}
		{city}
	</address>
</DatasheetDetailBlock>
